var NestedModel = require('./nested_model');
var BBModel = Backbone.Model;

var SearchSegmentModel = NestedModel.extend({
    nestedProps: {
        departure: BBModel,
        destination: BBModel,
    },
});

var SearchSegmentCollection = Backbone.Collection.extend({
    model: SearchSegmentModel,
});

var updateStoredProps = function(model) {
    var attrs = model.toJSON();
    Odigeo.Session.set('searchParameters', JSON.stringify(attrs));
};

var CurrentSearchModel = NestedModel.extend({
    initialize: function() {
        this.listenTo(this, 'change', updateStoredProps);
    },
    nestedProps: {
        searchSegments: SearchSegmentCollection,
    },
});

var instance;

module.exports = {
    getInstance: function() {
        if (_.isUndefined(instance)) {
            instance = new CurrentSearchModel();
        }
        return instance;
    },
};
